import { REGEX_DIGITS_ONLY } from 'clickNgo/configs/regex'

export const checkDigitsOnly = async (value: string) => {
  return !REGEX_DIGITS_ONLY.test(value) ? 'Use digits only' : ''
}
